<template>
  <!-- 返佣统计页面 -->
  <div id="agentRebateData">
    <!-- 头部数据更新时间模块 -->
    <headerUpdate></headerUpdate>
    <b-card class="header-top" ref="headerH">
      <div class="header-page-title">
        <div class="title">
          {{ currentPageTitle }}
        </div>
      </div>
      <b-row>
        <b-col lg="9">
          <!-- 返佣对象 -->
          <b-form-group class="find-middle">
            <label>
              <el-tooltip placement="top">
                <div slot="content" :style="{ maxWidth: tipWidth }">
                  {{ $t("lanV4.ReturnedCommissionTip") }}
                </div>
                <span class="el_tooltip_bor">
                  {{ $t("lanV4.ReturnedCommission") }}</span>
              </el-tooltip>
            </label>
            <v-select class="find-select" v-model="returnTo" :options="returnToArr"
              :disabled="roleType == 0 || roleType == 1">
              <div slot="no-options">{{ $t("common.noFind") }}</div>
            </v-select>
          </b-form-group>
          <!--返佣对象uid-->
          <b-form-group v-if="returnTo.value == 1" class="find-middle" :style="{
            width: lan === 'zh_CN' || lan === 'el_GR' ? '200px' : '267px',
          }">
            <b-form-input v-model.trim="pid" maxLength="15"
              :placeholder="$t('lanV4.ReturnedCommissionUid')"></b-form-input>
          </b-form-group>
          <!--返佣级别-->
          <b-form-group class="find-middle">
            <label>
              <el-tooltip placement="top">
                <div slot="content" :style="{ maxWidth: tipWidth }">
                  {{ $t("lanV4.ReturnedCommissionLevelTip") }}
                </div>
                <span class="el_tooltip_bor">
                  {{ $t("lanV4.ReturnedCommissionLevel") }}</span>
              </el-tooltip>
            </label>
            <v-select class="find-select" v-model="level" :options="levelArray" :disabled="!!!pid">
              <div slot="no-options">{{ $t("common.noFind") }}</div>
            </v-select>
          </b-form-group>

          <b-form-group :label="$t('common.date')" class="find-middle">
            <el-date-picker v-model="dateArray" unlink-panels type="daterange" range-separator="-"
              :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')"
              value-format="yyyy/MM/dd" @change="handleChangeDate" :clearable="false" :picker-options="pickerOptions">
            </el-date-picker>
          </b-form-group>
        </b-col>
        <b-col lg="3" class="header-right-btn">
          <div class="find-middle find-btnBox">
            <b-button variant="primary" @click="query">
              <!-- <svg class="icon icon-14 icon-search" aria-hidden="true">
                <use xlink:href="#icon-v4_17"></use>
              </svg> -->
              {{ $t("common.search") }}</b-button>
            <b-button variant="light" @click="reset">
              <!-- <svg class="icon icon-14 icon-reset" aria-hidden="true">
                <use xlink:href="#icon-v4_3"></use>
              </svg> -->
              {{ $t("common.reset") }}</b-button>
          </div>
        </b-col>
      </b-row>
      <!-- 头部分割线 -->
      <div class="header-top-bottom-bor"></div>
    </b-card>
    <div class="invite-data-md">
      <div class="title">
        <!-- 数据总览 -->
        {{ $t("lanV4.Datascreening") }}
      </div>
      <div class="invite-card-box">
        <ul>
          <li>
            <div class="num enNum">
              <span v-if="sumReturnAmount >= 0 && sumReturnAmount != null && !showEmpty">
                {{ sumReturnAmount }}</span>
              <span v-else>--</span>
            </div>
            <div class="text">
              <a id="tooltip-target-1" href="javascript:">
                <!-- 收到的返佣 -->
                {{ $t("lanV4.Receivedcommission") }}
              </a>
              <b-tooltip target="tooltip-target-1" triggers="hover">
                <!-- 含自返佣 -->
                {{ $t("lanV4.ReceivedcommissionTip") }}
              </b-tooltip>
            </div>
          </li>
          <li>
            <div class="num enNum">
              <span v-if="sumTradeAmount >= 0 && sumTradeAmount != null && !showEmpty">
                {{ sumTradeAmount }}</span>
              <span v-else>--</span>
            </div>
            <div class="text">
              <a id="tooltip-target-2" href="javascript:">
                <!-- 交易额 -->
                {{ $t("lanV4.ReceivedcommissionAmount") }}
              </a>
              <b-tooltip target="tooltip-target-2" triggers="hover">
                <!-- 所选返佣级别用户的合约交易额总和，非U币种按照统计时的汇率折算成USDT，包含开仓和平仓，不包含模拟合约 -->
                {{ $t("lanV4.ReceivedcommissionAmountTip") }}
              </b-tooltip>
            </div>
          </li>
          <li>
            <div class="num enNum">
              <span v-if="sumTradeNum >= 0 && sumTradeNum != null && !showEmpty">
                {{ sumTradeNum }}</span>
              <span v-else>--</span>
            </div>
            <div class="text">
              <a id="tooltip-target-3" href="javascript:">
                <!-- 交易次数 -->
                {{ $t("lanV4.ReceivedcommissionNum") }}
              </a>
              <b-tooltip target="tooltip-target-3" triggers="hover">
                <!-- 所选返佣级别用户的合约交易次数总和，非U币种按照统计时的汇率折算成USDT，同一委托多次成交算一次交易，时间按提交时间，包含开仓和平仓，不包含模拟合约 -->
                {{ $t("lanV4.ReceivedcommissionNumTip") }}
              </b-tooltip>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <b-card class="table-card">
      <div slot="header">
        <div class="table-title float-left">
          <!-- 数据总览 标题 -->
          <!-- {{ $t("lanV4.Datascreening") }} -->
          <span v-if="pages.total > 0">
            {{ $t("el.pagination.total", { total: pages.total }) }}
          </span>
        </div>
        <!-- <v-page
          class="float-left"
          v-if="pages.total > 0"
          :total-rows="pages.total"
          :perPage="pages.size"
          :pageOptions="pages.options"
          :currentPage="pages.page"
          @initialize="pageChange"
          layout="total,sizes"
        >
        </v-page> -->
        <!-- 导出 -->
        <b-button v-if="pages.total > 0" class="float-right btn-export" variant="light"
          :class="!isexportIng ? 'lodingSattus' : ''" @click="exports">
          <svg class="icon icon-16" aria-hidden="true">
            <use xlink:href="#icon-v4_6_h"></use>
          </svg>
          {{ exportButtonText }}
          <svg v-if="!isexportIng" class="icon icon-20 btn-loading" aria-hidden="true">
            <use xlink:href="#icon-v4_loading"></use>
          </svg>
        </b-button>
      </div>
      <b-row>
        <b-col class="table-section">
          <el-table :height="$store.state.baseData.tableH" class="table-container" :data="tableList"
            @sort-change="sortChanged" :cell-class-name="addEnClass"
            :default-sort="{ prop: 'returnAmount', order: 'descending' }">
            <template slot="empty">
              <load-skeleton v-show="loading" :columns="6" :rows="10" :haveLeftNumber="false"></load-skeleton>
              <h4 class="common-table-noData" v-show="!loading">
                <img src="../../assets/images/v4_nodata.png" alt="" />
                <div class="noData-text">
                  {{ $t("common.noData") }}
                </div>
              </h4>
            </template>
            <!-- uid -->
            <el-table-column prop="uid" align="left">
              <template slot-scope="scope" slot="header">
                <el-tooltip placement="top">
                  <div slot="content" style="max-width: 200px">
                    {{ $t("lanV4.UIDTip") }}
                  </div>
                  <span> {{ $t("lanV4.newUid") }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <!-- pid -->
            <el-table-column prop="pid" align="right">
              <template slot-scope="scope" slot="header">
                <el-tooltip placement="top">
                  <div slot="content" style="max-width: 200px">
                    {{ $t("lanV4.PIDTip") }}
                  </div>
                  <span> {{ $t("lanV4.PID") }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <!-- 返佣级别 -->
            <el-table-column prop="returnLevel" :label="$t('lanV4.ReturnedCommissionLevel')" align="right">
            </el-table-column>
            <!--  交易额 -->
            <el-table-column prop="tradeAmount" align="right" sortable="'custom'" width="200">
              <template slot-scope="scope" slot="header">
                <el-tooltip placement="top">
                  <div slot="content" style="max-width: 200px">
                    {{ $t("lanV4.ReceivedcommissionAmountTip2") }}
                  </div>
                  <span> {{ $t("lanV4.ReceivedcommissionAmount") }}</span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <span class="enNum">
                  {{ scope.row.tradeAmount }}
                </span>
              </template>
            </el-table-column>

            <!--  手续费 -->
            <el-table-column prop="fee" align="right" sortable="'custom'" width="200">
              <template slot-scope="scope" slot="header">
                <el-tooltip placement="top">
                  <div slot="content" style="max-width: 200px">
                    {{ $t("lanV4.agentFeeTip") }}
                  </div>
                  <span> {{ $t("lanV4.agentFee") }}</span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <span class="enNum">
                  {{ scope.row.fee }}
                </span>
              </template>
            </el-table-column>

            <!--  返佣 -->
            <el-table-column prop="returnAmount" align="right" sortable="'custom'" width="200"
              :label="$t('lanV4.CommissionRebate')">
              <template slot-scope="scope" slot="header">
                <el-tooltip placement="top">
                  <div slot="content" style="max-width: 200px">
                    {{ $t("lanV4.CommissionRebateTip") }}
                  </div>
                  <span> {{ $t("lanV4.CommissionRebate") }}</span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <span class="enNum">
                  {{ scope.row.returnAmount }}
                </span>
              </template>
            </el-table-column>

            <!-- 操作 -->
            <el-table-column prop="action" :label="$t('lanV4.Rebatedetail')" fixed="right" align="right" width="210">
              <template slot-scope="scope">
                <!-- 查看 -->
                <b-button size="sm" variant="outline-primary" @click="handleView(scope.row)">
                  {{ $t("common.view") }}
                </b-button>
              </template>
            </el-table-column>
          </el-table>
        </b-col>
      </b-row>
      <b-row class="mar-t-20">
        <b-col>
          <v-page v-if="pages.total > 0" :total-rows="pages.total" :perPage="pages.size" :pageOptions="pages.options"
            :currentPage="pages.page" @initialize="pageChange"></v-page>
        </b-col>
      </b-row>
    </b-card>

    <!-- 导出10000条提示 -->
    <b-modal v-model="exportsModalShow" :title="$t('exportsModal.text1')" size="md" centered scrollable
      no-close-on-backdrop id="code-modal">
      <div class="body-content">
        <div class="expor-number-tip">
          {{ $t("exportsModal.text2", { pagesTotal: pages.total, maxNum: exportNumLimit }) }}
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button class="coustom-btn" variant="secondary" @click="onReset">{{
          $t("common.cancel")
          }}</b-button>
        <b-button class="coustom-btn" variant="primary" @click="exports('true')"
          :class="!isexportIng ? 'lodingSattus' : ''">
          <template v-if="!isexportIng">
            {{ $t("common.exportIng") }}
          </template>
          <template v-else>
            <!-- 继续导出 -->
            {{ $t("exportsModal.text3") }}
          </template>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import commonMixin from "@/mixin/common/commonMixin";
import { fixD, fixInput, formatTime, formatTimeDay } from "@/apis/newmethods";
import headerUpdate from "./components/headerUpdate.vue";
export default {
  name: "agentRebateData",
  mixins: [commonMixin],
  components: {
    headerUpdate,
  },
  data() {
    return {
      returnTo: null, //返佣对象
      searchRuturnTo: null, //返佣对象 - 结果对应的条件
      pid: null, // pid 返佣对象uid
      searchPid: null, // pid 返佣对象uid - 结果对应的条件
      dateArray: [],
      beginDate: null,
      endDate: null,
      sumReturnAmount: null, //收到的返佣
      sumTradeAmount: null, //交易额
      sumTradeNum: null, //交易次数
      level: null, //返佣级别
      levelArray: [], //返佣级别下拉
      // 当天之后的时间无法选择
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > window.Date.now();
        },
      },

      pages: {
        page: 1, // 当前页数
        size: 10, // 页数大小
        options: [10, 40, 60, 100], // 页数大小选择
        total: 0, // 总页数
      },
      notData: true,
      loading: false,
      tableList: [],
      modalShow: false,
      isexportIng: true,
      sortBy: null, //预先排序的字段
      sortDesc: true, //预先降序
      sortName: "returnAmount", //默认排序字段
      sortSet: 1, //默认倒序
    };
  },
  computed: {
    showEmpty() {
      return [0, 1, 3, 4].includes(this.roleType) && this.searchRuturnTo == 1 && !this.searchPid;
    },
    // 返佣对象
    returnToArr() {
      return [
        {
          label: this.$t("lanV4.ReturnedCommissionMy"), //我
          value: 0,
        },
        {
          label: this.$t("lanV4.ReturnedCommissionThe"), //他人
          value: 1,
        },
      ];
    },
    exportButtonText() {
      if (!this.isexportIng) {
        return this.$t("common.exportIng"); // '正在导出'
      }
      return this.$t("common.export");
    },
  },
  watch: {
    pid(v) {
      if (v) {
        this.$nextTick(() => {
          this.pid = fixInput(v, 0, { num: 1 });
        });
      } else {
        this.level = this.levelArray[0];
      }
    },
  },
  created() {
    if (this.roleType == 0 || this.roleType == 1) {
      this.returnTo = this.returnToArr[1];
    } else {
      this.returnTo = this.returnToArr[0];
    }
    this.getLastMonthOne();
    this.getReturnLevel();
    this.level = this.levelArray[0];
    if (this.returnTo.value == 0) {
      this.getData();
    } else {
      this.query();
    }
  },
  methods: {
    changeId(val) {
      console.log(val, !!!val);
      if (!!!val) {
        this.level = this.levelArray[0];
      }
    },
    // 选择时间
    handleChangeDate() {
      this.beginDate = this.dateArray[0];
      this.endDate = this.dateArray[1];
    },
    // 最近一月
    getLastMonthOne() {
      var end = new window.Date(new window.Date());
      var year = end.getFullYear();
      var month = end.getMonth() + 1; //0-11表示1-12月
      var day = end.getDate();
      var dateObj = {};
      dateObj.end = year + "-" + month + "-" + day;
      var endMonthDay = new window.Date(year, month, 0).getDate(); //当前月的总天数
      if (month - 1 <= 0) {
        //如果是1月，年数往前推一年<br>
        dateObj.start = year - 1 + "-" + 12 + "-" + day;
      } else {
        var startMonthDay = new window.Date(
          year,
          parseInt(month) - 1,
          0
        ).getDate();
        if (startMonthDay < day) {
          //1个月前所在月的总天数小于现在的天日期
          if (day < endMonthDay) {
            //当前天日期小于当前月总天数
            dateObj.start =
              year +
              "-" +
              (month - 1) +
              "-" +
              (startMonthDay - (endMonthDay - day));
          } else {
            dateObj.start = year + "-" + (month - 1) + "-" + startMonthDay;
          }
        } else {
          dateObj.start = year + "-" + (month - 1) + "-" + day;
        }
      }
      this.beginDate = new window.Date(
        dateObj.start.replace(/-/g, "/")
      ).getTime();
      this.endDate = new window.Date(dateObj.end.replace(/-/g, "/")).getTime();

      this.dateType = 1;
      this.dateArray = [
        formatTimeDay(this.beginDate),
        formatTimeDay(this.endDate),
      ];
    },
    // 英文数字字体
    addEnClass({ row, column }) {
      switch (column.property) {
        case "uid":
          return "enNum";
        case "pid":
          return "enNum";
        case "tradeAmount":
          return "enNum";
        case "fee":
          return "enNum";
        case "returnAmount":
          return "enNum";
      }
    },
    // 排序变化
    sortChanged(ctx) {
      switch (ctx.prop) {
        case "tradeAmount":
          this.sortName = "tradeAmount";
          break;
        case "fee":
          this.sortName = "fee";
          break;
        case "returnAmount":
          this.sortName = "returnAmount";
          break;
      }
      this.sortSet = ctx.order === "descending" ? 1 : 0;
      this.getData();
    },
    // 获取返佣级别下拉
    getReturnLevel() {
      this.$http({
        url: this.$store.state.url.agent.level_list,
        params: {
          startTime: this.dateArray
            ? new window.Date(this.beginDate).getTime()
            : null,
          endTime: this.dateArray
            ? new window.Date(this.endDate).getTime()
            : null,
          returnTo: this.returnTo ? this.returnTo.value : null, //返佣对象(0:我，1:他人)
          pid: this.pid,
          returnLevel: this.level ? this.level.value : null,
          pageNum: this.pages.page,
          pageSize: this.pages.size,
          sortName: this.sortName, //按参数排序
          isSort: this.sortSet, //1  倒序
          isExport: 0,
          type: 2,//返佣统计2,1返佣明细页面,处理返佣等级下拉展示
        },
        // method: "get",
        // apiType: "fe-json-server",
      }).then(({ data, code, msg }) => {
        if (data && code.toString() === "0") {
          let arr = [];
          arr.push({ label: this.$t("common.all"), value: null });
          if (data) {
            data.levelArray.map((item) => {
              arr.push({ label: item.levelName, value: item.level });
            });
            this.levelArray = arr;
            if(!this.level){
              this.level = arr[0];
            }
          }
        } else {
          this.$bus.$emit("alert", { type: "error", message: msg });
        }
      });
    },
    // 查看
    handleView(row) {
      const queryObj = {
        returnTo: this.returnTo ? this.returnTo.value : "",
        pid: row.pid,
        searchUid: row.uid,
        startTime: new window.Date(
          this.dateArray[0] + " " + "00:00:00"
        ).getTime(),
        endTime: new window.Date(
          this.dateArray[1] + " " + "00:00:00"
        ).getTime(),
        btnType: "view", //查看
      };
      this.$router.push({ path: "/agentRebateDetial", query: queryObj });
    },
    // 搜索
    query() {
      // if (
      //   (this.pid == null || this.pid == "") &&
      //   this.returnTo &&
      //   this.returnTo.value == 1
      // ) {
      //   // 请输入返佣对象的UID
      //   this.$bus.$emit("alert", {
      //     type: "error",
      //     message: this.$t("lanV4.ReturnedCommissionUid2"),
      //   });
      // } else {
      //   this.pages.page = 1;
      //   this.loading = true;
      //   this.getData();
      // }
      this.pages.page = 1;
      this.loading = true;
      this.getReturnLevel();
      this.getData();
    },
    // 重置
    reset() {
      this.pid = null;
      this.getLastMonthOne();
      this.level = this.levelArray[0];
      if (this.roleType == 0 || this.roleType == 1) {
        this.returnTo = this.returnToArr[1]; //他人
      } else {
        this.returnTo = this.returnToArr[0]; //我
      }
    },
    // 获取数据列表
    getData() {
      this.loading = true;
      this.tableList = [];
      const paramsData = {
        startTime: this.dateArray
          ? new window.Date(this.beginDate).getTime()
          : null,
        endTime: this.dateArray
          ? new window.Date(this.endDate).getTime()
          : null,
        returnTo: this.returnTo ? this.returnTo.value : null, //返佣对象(0:我，1:他人)
        pid: this.pid,
        returnLevel: this.level ? this.level.value : null,
        pageNum: this.pages.page,
        pageSize: this.pages.size,
        sortName: this.sortName, //按参数排序
        isSort: this.sortSet, //1  倒序
        isExport: 0,
      };
      this.searchRuturnTo = this.returnTo ? this.returnTo.value : null;
      this.searchPid = this.pid;
      this.$http({
        url: this.$store.state.url.agent.user_bonus_stat_list,
        params: paramsData,
        // method: "get",
        // apiType: "fe-json-server",
      })
        .then(({ data, code, msg }) => {
          this.loading = false;
          if (data && code.toString() === "0") {
            this.setData(data);
          } else {
            this.$bus.$emit("alert", { type: "error", message: msg });
          }
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    setData(datas) {
      const { returnInfo } = datas;
      this.pages.total = returnInfo ? returnInfo.total : 0;
      let arr = [];
      if (returnInfo && returnInfo.records.length) {
        returnInfo.records.map((item, index) => {
          arr.push({
            uid: item.uid,
            pid: item.pid,
            returnLevel: item.returnLevel,
            tradeAmount: item.tradeAmount,
            fee: item.fee,
            returnAmount: item.returnAmount, //返佣金额
            returnTo: item.returnTo, //返佣对象
            // sort: (this.pages.page - 1) * this.pages.size + (index + 1), //序号
          });
        });
      }
      if (arr.length === 0) {
        this.notData = true;
      }
      this.tableList = arr;
      this.sumReturnAmount = datas.sumReturnAmount;
      this.sumTradeAmount = datas.sumTradeAmount;
      this.sumTradeNum = datas.sumTradeNum;
    },
    // 导出
    exports(istrue) {
      if (
        istrue !== "true" &&
        this.pages.total &&
        Number(this.pages.total) > this.exportNumLimit
      ) {
        this.exportsModalShow = true;
      } else {
        if (!this.isexportIng) return;
        this.isexportIng = false;
        const paramsData = {
          startTime: this.dateArray
            ? new window.Date(this.beginDate).getTime()
            : null,
          endTime: this.dateArray
            ? new window.Date(this.endDate).getTime()
            : null,
          returnTo: this.returnTo ? this.returnTo.value : null, //返佣对象(0:我，1:他人)
          pid: this.pid,
          returnLevel: this.level ? this.level.value : null,
          pageNum: this.pages.page,
          pageSize: this.exportNumLimit,
          sortName: this.sortName, //按参数排序
          isSort: this.sortSet, //1  倒序
          isExport: 1,
        };

        this.outExcel(
          this.$store.state.url.agent.user_bonus_stat_list,
          paramsData,
          "increment-api"
        ).then((datas) => {
          if (datas.code === "0") {
            this.$bus.$emit("alert", {
              type: "success",
              message: this.$t("common.exportSuccess"),
            }); // 导出成功
            this.exportsModalShow = false;
            setTimeout(() => {
              this.isexportIng = true;
            }, 500);
          } else {
            this.$bus.$emit("alert", {
              type: "error",
              message: this.$t("common.exportError"),
            }); // 导出失败
          }
        });
      }
    },
    onReset() {
      this.exportsModalShow = false;
    },
    // 分页
    pageChange(data) {
      const { page, pageSize } = data;
      this.pages.page = page;
      this.pages.size = pageSize;
      const v = "page";
      this.getData(v);
    },
  },
};
</script>

<style lang="scss">
#agentRebateData {
  .custom-control {
    top: 5px !important;
  }

  .invite-data-md {
    width: 100%;
    border-radius: 16px;
    background: #fff;
    height: 142px;
    margin-top: 10px;
    padding: 24px 30px 30px 30px;
    line-height: 1;
    overflow: hidden;
    margin-bottom: 10px;

    .title {
      color: #8b909a;
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      font-family: HarmonyOS-Medium;
    }

    .invite-card-box {
      margin-top: 30px;

      ul {
        display: flex;

        li {
          margin-right: 110px;

          &:last-child {
            margin-right: 0px;
          }

          .num {
            color: #23272e;
            font-family: HarmonyOS-Bold !important;
            font-size: 24px;
            font-style: normal;
            font-weight: 700;
            line-height: 22px;
          }

          .text {
            color: #8b909a;
            font-family: HarmonyOS-Medium;
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
            margin-top: 8px;

            a {
              color: #93979d;
              text-decoration: none;
              border-bottom: 1px dotted;
            }
          }
        }
      }
    }
  }
}
</style>